import {bdpDateFormatShortYear} from '../../common/_BDPUtilities.jsx';

import SeriesOneGuidelines from './SeriesOneGuidelines.jsx';
import SeriesTwoGuidelines from './SeriesTwoGuidelines.jsx';
import SeriesThreeGuidelines from './SeriesThreeGuidelines.jsx';
import SeriesFourGuidelines from './SeriesFourGuidelines.jsx';
import SeriesFiveGuidelines from './SeriesFiveGuidelines.jsx';
import SeriesSixGuidelines from './SeriesSixGuidelines.jsx';
import SeriesSevenGuidelines from './SeriesSevenGuidelines.jsx';
import SeriesEightGuidelines from './SeriesEightGuidelines.jsx';

export default function GuidelinesContent(seriesList) {
	function returnSubmissionDate(series) {
		if(seriesList && seriesList.length > 0) {
			const seriesIdx = seriesList.findIndex(seriesItem => seriesItem.idSeries == series);

			if(seriesIdx == -1) {
				return 'TBD';
			}else{
				return bdpDateFormatShortYear(seriesList[seriesIdx].udtCrowdSourcingStart);
			}
		}
	}

	return [
			{id: 0, seriesNum: 1, title: 'Series 1 Guidelines', content: SeriesOneGuidelines(returnSubmissionDate(1))}
		,	{id: 1, seriesNum: 2, title: 'Series 2 Guidelines', content: SeriesTwoGuidelines(returnSubmissionDate(2))}
		,	{id: 2, seriesNum: 3, title: 'Series 3 Guidelines', content: SeriesThreeGuidelines(returnSubmissionDate(3)), updateTitle: 'Series 3 Updates', updates: returnSeries3Updates()}
		,	{id: 3, seriesNum: 4, title: 'Series 4 Guidelines', content: SeriesFourGuidelines(returnSubmissionDate(4)), updateTitle: 'Series 4 Updates', updates: returnSeries4Updates()}
		,	{id: 4, seriesNum: 5, title: 'Series 5 Guidelines', content: SeriesFiveGuidelines(returnSubmissionDate(5)), updateTitle: 'Series 5 Updates', updates: returnSeries5Updates()}
		,	{id: 5, seriesNum: 6, title: 'Series 6 Guidelines', content: SeriesSixGuidelines(returnSubmissionDate(6)), updateTitle: 'Series 6 Updates', updates: returnSeries6Updates()}
		,	{id: 6, seriesNum: 7, title: 'Series 7 Guidelines', content: SeriesSevenGuidelines(returnSubmissionDate(7)), updateTitle: 'Series 7 Updates', updates: returnSeries7Updates()}
		,	{id: 7, seriesNum: 8, title: 'Series 8 Guidelines', content: SeriesEightGuidelines(returnSubmissionDate(8)), updateTitle: 'Series 8 Updates', updates: returnSeries8Updates()}
	];
}

function returnSeries3Updates() {
		return `<h3>Minifigures:</h3>
<p class="l-margin-bottom">Minifigures from different eras should not be mixed. For example, please do not use Classic Space minifigures with modern Space figures in the same model.</p>
<p>Minifigure heads with dual print need to have the back face print covered by hair or headwear.</p>

<h3>Stickers:</h3>
<p>Note: Stickers will be redesigned by a LEGO graphic designer.</p>

<h3>Building Instructions:</h3>
<p>Note: Building instructions will be redesigned by a LEGO graphic designer.</p>

<h3>Submission Upload:</h3>
<p>Model images can only include the models included in the design. No reference models should be visible in background, or for scale. This includes “greyed” or “transparent” models in the background</p>`;
}

function returnSeries4Updates() {
		return `<h3>Working Models:</h3>
<p class="l-margin-bottom">Doors must have a door handle on the outside, not the inside. Handles on the inside prevent the door from opening.</p>
<div class="crowd-guidelines-image crowd-guidelines-image--update">
	<img src="//${blapp.config.getHost( "static2" )}/img/bdp/guidelines/handle-outside.png" style="width:478px"/>
</div>
<h3>Stickers:</h3>
<p class="l-margin-bottom">Whenever possible, use iconography or images instead of text on stickers.</p>
<p>Designers may not put their name, username, or identifiable information on stickers.</p>

<h3>Building Instructions:</h3>
<p>You are responsible for creating building instructions for your design that follow the requirements below. Note: Building instructions will be redesigned by a LEGO graphic designer, so your instructions are for build flow only (not graphical layout).</p>

<h3>Minifigures:</h3>
<p>Minifigures must be complete. You cannot remove head, arms, legs, hips, or hands from minifigure torso.</p>`;
}

function returnSeries5Updates() {
		return `<h3>Stickers:</h3>
<p class="l-margin-bottom">When designing custom parts using the <a href="//www.bricklink.com/v3/studio/partdesigner.page">Studio tool Part Editor</a>, save all custom stickered parts with the part name and color in the name. For example, for a 2x4 tile with a dog bone graphic on the sticker, you could name the part file “2x4 Tile Red Dog Bone.” This will help the design team when reviewing your submission.</p>`;
}
function returnSeries6Updates() {
	return `<h3>Theme:</h3>
	<p>In order to help us project a vision of a sustainable future, we wish for you to adhere to these additional guidelines:</p>
	<ol class="letter-list l-margin-bottom l-margin-top">
		<li class="l-margin-bottom--sm">Avoid depicting harm to animals (e.g. hunting and trapping; tied-up, caged or dead animals). Fishing is acceptable as well as the usage of any standard element that is used to depict a food element (e.g. part 64648).</li>
		<li class="l-margin-bottom--sm">Avoid depicting wild animals in zoos, circuses, aquariums or other situations that are designed for human entertainment. Please only show wild animals in their natural habitats.</li>
		<li class="l-margin-bottom--sm">Avoid highlighting fossil fuels like coal, oil, and gas (e.g. depicting refineries, fuel storage or gas stations). It’s acceptable to showcase historical methods of transportation that rely on fossil fuels (e.g. steam locomotives). Modern vehicles need to adhere to this guideline, therefore the propulsion method should be ambiguous if it is not a sustainable power source.</li>
	</ol>
	<p>Models may not be based off the following internal LEGO IP:</p>
	<p class="l-margin-bottom">NINJAGO®, Dreamzzz, Friends, Monkie Kid, and the ICONS Modular format.</p>
	<p>Buildings are acceptable to submit to BDP, but they should not reflect the Modular format. If a building looks similar to the design language of the ICONS Modular subtheme (row style building, separating floors, etc) it should use a different base technique. Buildings should also not copy the ICONS Modular baseplate layout design language directly (32x32 baseplate, sidewalk with lamps, Technic connection points). When we review BDP submissions, we will ask “could this model be confused as an ICONS Modular building?”</p>
	<h3>Part Selection:</h3>
	<p class="l-margin-bottom">Each minifigure head may only be used once in a submission. Skeleton heads do not apply to this rule.</p>
	<h3>Minifigures:</h3>
	<p class="l-margin-bottom">There’s a maximum of one minifigure for every 325 parts. See this table for minifigure count limits based on your part count. Skeletons do not count as minifigures.</p>
	<h3>Prepare Submission Info Ahead Of Time:</h3>
	<p>Design Title</p>
	<ol class="letter-list l-margin-top">
		<li class="l-margin-bottom--sm">Design title cannot include LEGO in the title or any other LEGO property.</li>
		<li class="l-margin-bottom--sm">Buildings should not include “Modular” in the title.</li> 
		<li class="l-margin-bottom--sm">Castle and Classic Space models should not include the faction name in the title (e.g. Lion Knight, Wolfpack, Blacktron, etc).</li>
	</ol>
	`;
}
function returnSeries7Updates() {
	return `<p>In order to help us project a vision of a sustainable future, we wish for you to adhere to these additional guidelines:</p>
	<ol class="letter-list l-margin-bottom l-margin-top">
		<li class="l-margin-bottom--sm">Avoid highlighting fossil fuels like coal, oil, and gas (for example, depicting refineries, factory chimneys, fuel storage, or gas stations). It’s acceptable to showcase historical methods of transportation that rely on fossil fuels (e.g. steam locomotives). When honoring existing real-world vehicles, fossil-fueled ones are acceptable. For generic vehicles, consider making them electric to fit a playable and fantastic universe.</li>
		<li class="l-margin-bottom--sm">Avoid showing any destruction of natural environments for human benefit (e.g. deforestation, logging, mining, land development, monoculture plantations, etc.)</li>
	</ol>`;
}
function returnSeries8Updates() {
	return `<h3>Theme:</h3>
<p class="l-margin-bottom--sm">Models may not be based off the following internal LEGO IP: </p>
<p class="l-margin-top--null">NINJAGO®, Dreamzzz, Friends, Monkie Kid, BrickHeadz and the ICONS Modular format. </p>

<h3>Minifigures:</h3>
<p>Each minifigure head may only be used once.  Skeleton, statue, classic smile and alien heads do not apply to this rule. </p>`;
}